import Vue from 'vue'
import Router from 'vue-router'
import Home from './home'
import org from '../config/organization'
import mobile from "../common/mobile-input"

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
      ...Home,
    {
      path: '/sign-in',
      name: 'sign-in',
      meta:{public:true},
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      // 只有将写成这样才能够识别出来，否则报module没有发现
      component: () => import(/* webpackChunkName: "about" */  '../views/' + mobile()+ org.logon_template )
      //component:SignIn
    },
    {
      path: '/host',
      name: 'host',
      meta:{public:true},
      component: () => import(/* webpackChunkName: "host" */ '../views/'+ mobile()+'host.vue')
    },
    {
      path: '/sso/login',
      name: 'sso-login',
      redirect: '/sign-in',
      props:true,
    },
    {
      path:'*',
      name:'default',
      redirect:'/',
    }
  ]
})

